import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const badPoints = ['Ultraprocesados llenos de químicos y conservantes', 'Inflamación crónica y falta de energía constante', 'Desconexión total con el origen de lo que comes', 'Dependencia de sabores artificiales y azúcar', 'Problemas digestivos y salud debilitada'];
  const goodPoints = ['Ingredientes 100% naturales y vivos', 'Energía vital y desinflamación natural', 'Conexión profunda con la sabiduría de la tierra', 'Sabores auténticos que nutren el alma', 'Sistema inmune fuerte y digestión perfecta'];
  return <section id="comparison" className="py-24 relative z-10 bg-[#f5f0e1] pt-[0px] pb-[0px]" data-id="element-100">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="text-center mb-6 px-4 relative" data-id="element-101">
        <div className="absolute inset-0 bg-[#8b7355]/10 blur-3xl rounded-full -z-10" data-id="element-102" />
        <p className="italic md:text-4xl max-w-4xl mx-auto font-['Tiro_Gurmukhi',_serif] text-[#0C0100] font-bold text-[27px] pt-[0px] pb-[0px] mt-[20px] mb-[20px]" data-id="element-103">
          ¿Buscás una forma natural de sanar tu cuerpo sin depender de químicos
          ni soluciones artificiales?
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="w-full overflow-hidden" data-id="element-104">
        <img src="https://cdn.magicpatterns.com/uploads/3D9CQwn99rmyE8BaWaXkp6/web_2_(1).webp" alt="Problemas de la alimentación moderna" className="w-full h-auto block" data-id="element-105" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mt-20 mb-6 px-4 relative" data-id="element-106">
        <div className="absolute inset-0 bg-green-500/10 blur-3xl rounded-full -z-10" data-id="element-107" />
        <p className="italic md:text-4xl max-w-4xl mx-auto font-['Tiro_Gurmukhi',_serif] text-[#1a2e1a] font-bold text-[27px]" data-id="element-108">
          ¡Descubrí la solución definitiva con nuestro Recetario Ancestral y
          recuperá tu bienestar hoy mismo!
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="w-full overflow-hidden" data-id="element-109">
        <img src="https://cdn.magicpatterns.com/uploads/kVzjMofU96i4u2y2Vu65c5/positivo.webp" alt="Beneficios de la alimentación ancestral" className="w-full h-auto block pt-[0px] pb-[0px]" data-id="element-110" />
      </motion.div>
    </section>;
}